import { useAuthStore } from '@/stores/auth'

const useTypingCenter1038Overrides = () => {
  return [
    'transactionReason',
    'establishmentDetails',
    'applicantInformation',
    'communicationInformationSection',
    'graduationInformation'
  ]
}
const useTypingCenter1112Overrides = () => {
  return [
    'transactionReason',
    'applicantInformation',
    'communicationInformationSection',
    'graduationInformation'
  ]
}
export default async function (serviceId) {
  const authStore = useAuthStore()
  const typingCenterOverrides = {
    1038: useTypingCenter1038Overrides,
    1112: useTypingCenter1112Overrides,
    1113: useTypingCenter1112Overrides
  }
  const mapping = {
    ...(authStore.isUserTypingCenter && typingCenterOverrides)
  }
  if (Object.keys(mapping).some((m) => m == serviceId)) {
    return await mapping[serviceId]()
  }

  console.info(`There's no sections to hide override mapped for ${serviceId}`)
  return Promise.resolve([])
}
